<template>
    <div>
        <img :src="configTni.new_register_success_image_url" alt="" />
    </div>
</template>
<script>

//service
import ConsentApi from '../../ConsentRegister/service/ConsentApi';

export default {
    name: "NewRegisterSuccessPage",
    components: {
    },
    data: function() {
        return {
            configTni: {},
        }
    },
    created: function() {
        this.getBlobConfig();
    },
    methods: {
        getBlobConfig: function() {
            ConsentApi.apiGetTniConfig().subscribe({
                next: (data) => {
                    this.configTni = data;
                    
                },
                error: (err) => {
                    this.errorApi(err);
                },
            });
        },
    },
}
</script>
